var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { memo } from "react";
var SvgSecretSociety = function SvgSecretSociety(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 10.6,
    cy: 8.9,
    r: 1.9,
    transform: "rotate(30 10.6 9)",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14 3a5 5 0 1 0-.3 8.8l.7 1a6.2 6.2 0 1 1 .3-11z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.6 7.3A6.3 6.3 0 0 1 5.3 18l.6-1a5 5 0 1 0 .4-8.9l-.7-1q2.9-1.5 6 0",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
};
var Memo = /*#__PURE__*/memo(SvgSecretSociety);
export default Memo;